// extracted by mini-css-extract-plugin
export default {"draftSelector":"draft-selector__draftSelector--K5lub"};